module.exports = __webpack_public_path__ + "static/media/chat-default.473d6148.jpg";